<template>
  <div>
    <div class="d-flex w-100 choose">
      <v-btn
        class="auth-default-btn ma-0"
        @click="chooseAccount('listener')"
        :class="{ active: accountCategory == 'listener' }"
      >
        Listener
      </v-btn>

      <v-btn
        class="auth-default-btn ma-0"
        @click="chooseAccount('creator')"
        :class="{ active: accountCategory == 'creator' }"
      >
        Creator
      </v-btn>
    </div>

    <v-btn
      :class="{
        'auth-bg-disabled': checkDataEmpty,
        'auth-bg-active': !checkDataEmpty,
      }"
      class="auth-button"
      @click="handleNextStage()"
    >
      Next
    </v-btn>

    <div class="login mt-5">Already have an account?</div>

    <router-link class="d-flex justify-center mt-4" to="/login">
      <v-btn class="auth-default-btn max-w145"> Login </v-btn>
    </router-link>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      accountCategory: "",
      forceShowNextIcon: false,
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.app.onboarding.current,
      getAccountCategory: (state) => state.app.onboarding.accountCategory,
    }),
    validated() {
      const { accountCategory } = this;
      const toValidate = [accountCategory];

      const isValid = toValidate.every((item) => item);
      return isValid;
    },
    checkDataEmpty() {
      return this.accountCategory == "";
    },
  },
  methods: {
    ...mapActions({
      gotoNextStage: "app/nextOnboardingStage",
      gotoPrevStage: "app/prevOnboardingStage",
    }),
    ...mapMutations({
      updateOnboarding: "app/updateOnboarding",
    }),
    chooseAccount(category) {
      this.accountCategory = category;
      this.forceShowNextIcon = true;

      if (this.validated) {
        const data = {
          accountCategory: this.accountCategory,
        };
        this.updateOnboarding(data);
      }
    },
    handleNextStage() {
      if (this.validated) {
        const data = {
          accountCategory: this.accountCategory,
        };
        this.updateOnboarding(data);
        return this.gotoNextStage(this.current + 1);
      }
    },
  },
  created() {
    this.accountCategory = this.getAccountCategory;
  },
};
</script>

<style lang="scss" scoped>
.auth-default-btn {
  border-radius: 24px;
  background: #f8f8f8;
  box-shadow: 0px 2px 4px 0px #bdbfc0 !important;
  border: 0 !important;
  width: 357px;
  height: 50px;
}
.choose {
  flex-direction: column;
  gap: 29px;
}
.login {
  color: rgba(0, 0, 0, 0.7);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 187.5% */
  letter-spacing: -0.24px;
  text-align: center;
}

.auth-button {
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

.max-w145 {
  max-width: 145px;
}

.active {
  background: #4f56ff !important;
  box-shadow: 0px 2px 4px 0px #bdbfc0 !important;
  color: #fff !important;
}

@media screen and (max-width: 1280px) {
  .auth-button {
    border-radius: 56px;
  }
}
</style>



// WEBPACK FOOTER //
// chooseAccount.vue?7fc6ce70